/**
 * Pauses execution until the element != display: none;
 * @param element
 * @param callback
 * @returns {Promise<unknown>}
 */
export const onVisible = (element, callback = undefined) => {
    new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                if (callback) {
                    callback(element);
                }
                observer.disconnect();
            }
        });
    }).observe(element);
    if (!callback) return new Promise(r => callback = r);
}

/**
 * Fades an element in, if its opacity < 1.
 * @param el
 * @param duration
 */
export function fadeIn(el, duration = 25) {
    if (el.style.opacity < 1) {
        el.style.opacity = 0;
        el.style.display = 'block'; // Show the element
        let opacity = 0; // Initial opacity
        let interval = setInterval(function () {
            if (opacity < 1) {
                opacity += 0.1;
                el.style.opacity = opacity;
            } else {
                clearInterval(interval); // Stop the interval when opacity reaches 1
            }
        }, duration);
    }
}

/**
 * Fades an element out if its opacity is > 0.
 * @param el
 * @param duration
 */
export function fadeOut(el, duration = 25) {
    if (el.style.opacity > 0) {
        let opacity = 1; // Initial opacity
        let interval = setInterval(function () {
            if (opacity > 0) {
                opacity -= 0.1;
                el.style.opacity = opacity;
            } else {
                clearInterval(interval); // Stop the interval when opacity reaches 0
                el.style.display = 'none'; // Hide the element
            }
        }, duration);
    }
}

/**
 * Slide an element down if its not already visible.
 * @param target
 * @param duration
 */
export function slideDown(target, duration = 500) {

    // get the actual display value of the element
    const display = window.getComputedStyle(target).display;

    if(display === 'none') {
        target.style.removeProperty('display');
        let display = window.getComputedStyle(target).display;
        if (display === 'none') display = 'block';
        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout(() => {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }
}

/**
 * Slide an element up.
 * @param target
 * @param duration
 */
export function slideUp(target, duration = 500) {

    // get the actual display value of the element
    const display = window.getComputedStyle(target).display;

    if(display !== 'none') {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout(() => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }
}

/**
 * Changes the property of an element over a given duration.
 * @param target
 * @param attr
 * @param value
 * @param duration
 */
export function animateElement(target, attr, value, duration = 500) {
    target.style.transitionProperty = attr;
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style[attr] = value;
    window.setTimeout(() => {
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}
